<h2 class="interaction-title">
    <app-node-renderer [node]="node.Text"></app-node-renderer>
</h2>
